﻿"use strict";
import creator from '../elementCreator';

var privateFns;
privateFns = {
	createAttributionDiv: function (values){
		var attributionContainer, attribution;
		attributionContainer = creator.createDiv({id: "attribution-ct", css: "first-level"});
		attribution = creator.createA({href: "#", id: values.id, text: values.text})
		attributionContainer.appendChild(attribution);
		attributionContainer.setAttribute("aria-label", values.aria);
		document.getElementById(values.parent).appendChild(attributionContainer);
		privateFns.createDisclaimerWindow(values);
		privateFns.addTriggers(values.id);
		return;
	},
	
	createDisclaimerWindow: function (values){
		
		//<div class="copyright-win floating-win" data-enhance="false" id = "floatingWin"></div>
		
		var floatingWin, container, header, button, section, article, footer, icon;
		
		floatingWin = creator.createDiv({css: "copyright-win floating-win"});
		floatingWin.setAttribute("data-enhance","false");
		floatingWin.id = "floatingWin";
		
		container = creator.createDiv({})
		
		header  = creator.createHeader({css: "top-div"});
		
		button = creator.createButton({css: "close-me hide-me"});
		
		icon = creator.createIcon({css: "glyphicon glyphicon-remove"});
		
		button.appendChild(icon);
		header.appendChild(button);
		container.appendChild(header);
		
		section = creator.createSection(({}));
		
		article = creator.createArticle({text: values.article});
		section.appendChild(article);
		footer = creator.createFooter({
			text:'<a href="https://www.oslo.kommune.no/startsiden/personvern-og-informasjonskapsler-article3008.html" target="_blank">Personvern og informasjonskapsler <i class="icon-new-window"></i></a>'
		});
		
		section.appendChild(footer);
		container.appendChild(section);
		
		floatingWin.appendChild(container);
		document.getElementById("map").appendChild(floatingWin);
		return;
	},
	addTriggers: function(id){
		$(".hide-me").click(function (e) {
			$(e.currentTarget).closest(".floating-win").hide(300);
		});
		$("#attribution-ct").find("a").click(function (e) {
			if (e.currentTarget.id === id) {
				$(".copyright-win").show(300);
			}
		});
	}
}

// Legg til ekstra css-filer
$("head").append("<link rel='stylesheet' type='text/css' href='./css/attributionPlugin.css'>");
    
export default {
	initiate: function(values){
		privateFns.createAttributionDiv(values);
	}
};
